import { render, staticRenderFns } from "./_studyChoose.vue?vue&type=template&id=3df781bb&scoped=true"
import script from "./_studyChoose.vue?vue&type=script&lang=js"
export * from "./_studyChoose.vue?vue&type=script&lang=js"
import style0 from "./_studyChoose.vue?vue&type=style&index=0&id=3df781bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df781bb",
  null
  
)

export default component.exports